// Saves the visitor's cookie choice. The consent prompt can stay open for a long
// time, so the token captured at page load may no longer match the browser's
// session (session cookie expired, restored tab, sign-in/out in another tab).
// Prefer the current XSRF-TOKEN cookie, and when the server reports an invalid
// authenticity token, establish a fresh session once and retry. CSRF
// verification itself is unchanged.
export const STALE_SESSION_CODE = 'invalid_authenticity_token'
const SESSION_REFRESH_PATH = '/cookie-policy'

export const currentCsrfToken = (documentRef, fallback = '') => {
  try {
    const match = String(documentRef?.cookie || '').match(/(?:^|;\s*)XSRF-TOKEN=([^;]+)/)
    if (match) return decodeURIComponent(match[1])
  } catch (_error) {
    // Fall back to the token rendered with the page.
  }
  return fallback
}

const consentRequest = (choice, token) => ({
  method: 'POST',
  credentials: 'same-origin',
  cache: 'no-store',
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': token,
  },
  body: JSON.stringify({ cookie_consent: { analytics: choice.analytics, marketing: choice.marketing } }),
})

const staleSession = async response => {
  if (response.status !== 422) return false
  const data = await response.clone().json().catch(() => ({}))
  return data?.code === STALE_SESSION_CODE
}

export const saveCookieConsent = async (choice, {
  fallbackToken = '',
  fetchImpl = globalThis.fetch,
  documentRef = globalThis.document,
} = {}) => {
  try {
    let response = await fetchImpl('/cookie-consent', consentRequest(choice, currentCsrfToken(documentRef, fallbackToken)))

    if (await staleSession(response)) {
      const refresh = await fetchImpl(SESSION_REFRESH_PATH, {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'text/html' },
      })
      const refreshedToken = refresh.ok ? currentCsrfToken(documentRef, '') : ''
      if (refreshedToken) response = await fetchImpl('/cookie-consent', consentRequest(choice, refreshedToken))
    }

    return { ok: response.ok, status: response.status }
  } catch (_error) {
    return { ok: false, status: 0 }
  }
}
